import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    firstName: checkRequiredText(settings),
    lastName: checkRequiredText(settings),
    street: checkRequiredText(settings),
    postalCode: checkRequiredText(settings),
    city: checkRequiredText(settings),
    country: Yup.string().required("Angabe ist erforderlich"),
    emailAddress: Yup.string()
        .email("Bitte eine gültige E-Mail-Adresse angeben")
        .required("Angabe ist erforderlich"),
    phoneNumber: Yup.string()
        .matches(RegExp(settings.applicationPhoneNumberRegex), "Ungültige Telefonnummer"),
});

export const NameAndContactSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formFirstName">
                    <Form.Label>Vorname*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Vorname eingeben"
                        type="text"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.firstName && !errors.firstName}
                        isInvalid={touched.firstName && errors.firstName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.firstName}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formLastName">
                    <Form.Label>Name*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Nachname eingeben"
                        type="text"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.lastName && !errors.lastName}
                        isInvalid={touched.lastName && errors.lastName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formStreet">
                <Form.Label>Straße und Hausnummer*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Straße und Hausnummer eingeben"
                    type="text"
                    name="street"
                    value={values.street}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.street && !errors.street}
                    isInvalid={touched.street && errors.street}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.street}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPostalCode">
                <Form.Label>PLZ*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Postleitzahl eingeben"
                    type="text"
                    name="postalCode"
                    value={values.postalCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.postalCode && !errors.postalCode}
                    isInvalid={touched.postalCode && errors.postalCode}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.postalCode}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formCity">
                <Form.Label>Wohnort*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Wohnort eingeben"
                    type="text"
                    name="city"
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.city && !errors.city}
                    isInvalid={touched.city && errors.city}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.city}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formCountry">
                <Form.Label>Land*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="country"
                    value={values.country}
                    isValid={touched.country && !errors.country}
                    isInvalid={touched.country && errors.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.Country.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.country}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-Mailadresse*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="E-Mailadresse eingeben"
                    type="email"
                    name="emailAddress"
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.emailAddress && !errors.emailAddress}
                    isInvalid={touched.emailAddress && errors.emailAddress}
                    maxLength={settings.emailInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formPhoneNumber">
                    <Form.Label>Telefon</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Telefonnummer eingeben"
                        type="text"
                        name="phoneNumber"
                        value={values.phoneNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.phoneNumber && !errors.phoneNumber}
                        isInvalid={touched.phoneNumber && errors.phoneNumber}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="formMobileNumber">
                    <Form.Label>Mobiltelefon</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Mobiltelefonnummer eingeben"
                        type="text"
                        name="mobileNumber"
                        value={values.mobileNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.mobileNumber && !errors.mobileNumber}
                        isInvalid={touched.mobileNumber && errors.mobileNumber}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};